import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { CounselorNav } from '../counselor-nav/counselor-nav';
import { HasPermissionDirective } from '../../../../security/has-permission.directive';
import { USER_PERMISSIONS } from '../../../../constants/permissions';

@Component({
  selector: 'app-moderation',
  standalone: true,
  imports: [RouterModule, MatTabsModule, CounselorNav, HasPermissionDirective],
  templateUrl: './moderation.html',
  styleUrl: './moderation.css',
})
export class Moderation {
  readonly navLinks = [
    {
      path: '/counselors/moderation/reports',
      label: 'Reports',
      permission: USER_PERMISSIONS.MODERATION.VIEW_REPORTED,
      testId: 'reports',
    },
    {
      path: '/counselors/moderation/terms',
      label: 'Word Filter',
      permission: USER_PERMISSIONS.MODERATION.MANAGE_TERMS,
      testId: 'terms',
    },
  ];
}
